import { render } from "./SelectFace.vue?vue&type=template&id=98d2fe32&scoped=true"
import script from "./SelectFace.vue?vue&type=script&lang=js"
export * from "./SelectFace.vue?vue&type=script&lang=js"

import "./SelectFace.vue?vue&type=style&index=0&id=98d2fe32&lang=less&scoped=true"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d2fe32"]])

export default __exports__